"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEventString = createEventString;
exports["default"] = logCategoryActionLabel;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _webApiClientSingleton = _interopRequireDefault(require("../webApiClientSingleton"));
var _logging = require("../player/constants/logging");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function createEventString(event) {
  var category = event.category || _logging.categories.ad;
  return [category, event.action, event.label, event.value].join('|').replace(/\|+$/, ''); // removes any trailing `|`
}

function logCategoryActionLabel(event, moreParams) {
  var params = _objectSpread({
    c: 'eventlist',
    render: 'json'
  }, moreParams);
  var eventString = createEventString(event);
  var body = "event1=".concat(eventString);
  _webApiClientSingleton["default"].instance.logging.eventLog(params, body);
}
//# sourceMappingURL=logCategoryActionLabel.js.map